import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-ring',
  templateUrl: './progress-ring.component.html',
  styleUrls: ['./progress-ring.component.scss'],
  standalone: false
})
export class ProgressRingComponent {

  /**
   * Our progress ring functions by having a circle with a dashed border.
   * Only, the "dash" is one long dash the size of the full circumference of the circle.
   * We control the position of this dash through an offset:
   * • An offset of 0 means the full "dash" is in view.
   *   The loading spinner is at 100% in this state.
   * • An offset equal to the circumference means the "dash" is pushed all the way out
   *   of view. The loading spinner is at 0%.
   * There is another full circumference's gap before we encounter the next dash, so we'll
   * never see any other dashes.
   */

  @Input() progress = 0; // from 0.0 to 1.0
  @Input() size = 60;
  @Input() strokeWidth = 4;
  public get halfsize() { return this.size / 2; }
  public get radius() { return this.halfsize - this.strokeWidth; }
  public get circumference() { return this.radius * 2 * Math.PI; }
  public get strokeDasharray() { return `${this.circumference} ${this.circumference}`; }
  public get offset() { return this.circumference - (this.circumference * this.progress); }
}
